'use client';

var EStep;
(function (EStep) {
    EStep["Welcome"] = "Welcome";
    EStep["PersonalInformatoion"] = "PersonalInformatoion";
    EStep["HaveCV"] = "HaveCV";
    EStep["UploadCV"] = "UploadCV";
    EStep["BasicInformation"] = "BasicInformation";
    EStep["Skill"] = "Skill";
    EStep["WorkingPreference"] = "WorkingPreference";
    EStep["Recommendation"] = "Recommendation";
    EStep["Successfully"] = "Successfully";
})(EStep || (EStep = {}));

export { EStep };
//# sourceMappingURL=type.js.map
